import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#7540ee",
      d: "M21.082 6.484c-2.105-1.052-4.9-1.609-8.082-1.609s-5.977.557-8.082 1.609-3.293 2.533-3.293 4.079v4.874c0 1.546 1.2 3.032 3.293 4.08 2.092 1.046 4.9 1.608 8.082 1.608s5.977-.557 8.082-1.609 3.293-2.533 3.293-4.078v-4.876c0-1.545-1.2-3.031-3.293-4.078M13 6.5c6.362 0 9.75 2.36 9.75 4.063s-3.388 4.062-9.75 4.062-9.75-2.36-9.75-4.062C3.25 8.859 6.638 6.5 13 6.5m-.812 9.736v3.25c-1.93-.063-3.555-.348-4.876-.76v-3.182c1.592.424 3.229.656 4.876.692m1.624 0a20.7 20.7 0 0 0 4.876-.692v3.18c-1.32.413-2.946.698-4.875.76zM3.25 15.437v-1.875a8.4 8.4 0 0 0 1.668 1.08c.246.122.507.238.77.348v3.088c-1.608-.796-2.438-1.799-2.438-2.64m17.063 2.641V14.99q.399-.165.77-.349a8.4 8.4 0 0 0 1.667-1.08v1.877c0 .841-.83 1.844-2.437 2.64"
    }, null, -1)
  ]))]))
}
export default { render: render }